import React from 'react';
import {
  ShoppingOutlined,
  BarChartOutlined,
  ExclamationCircleOutlined,
  AccountBookOutlined,
  FileTextOutlined,
  BellOutlined,
  FundOutlined,
  LineChartOutlined,
  AppstoreOutlined,
  UserOutlined,
  SettingOutlined,
  ShopOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  SafetyCertificateOutlined,
  IdcardOutlined,
  BankOutlined,
  AuditOutlined,
  HomeOutlined,
  DownloadOutlined,
} from '@ant-design/icons';

import { TeamOutlined } from '@ant-design/icons';
// Pages
import Welcome from '../pages/system/Welcome';
import Orders from '../pages/order/OrderList';
import OrderAuditPage from '../pages/order/audit/OrderAudit';
import Departments from '../pages/manager/Departments';
import Staffs from '../pages/manager/Staffs';
import Roles from '../pages/manager/Roles';
import Permissions from '../pages/manager/Permissions';
import MainBodies from '../pages/manager/MainBodies';
import Accounts from '../pages/manager/Accounts';
import Shops from '../pages/manager/Shops';
import Brands from '../pages/manager/Brands';
import LockFeeConfigs from '../pages/manager/LockFeeConfigs';
import PreRatingThresholds from '../pages/manager/PreRatingThresholds';
import OverdueStoreStatistics from '../pages/overdue/OverdueStoreStatistics';
import OverdueBillsStatistics from '../pages/overdue/OverdueBillsStatistics';
import OverdueDataStatistics from '../pages/overdue/OverdueDataStatistics';
import OverdueAmountStatistics from '../pages/overdue/OverdueAmountStatistics';
import BadDebtDataStatistics from '../pages/overdue/BadDebtDataStatistics';
import BadDebtAmountStatistics from '../pages/overdue/BadDebtAmountStatistics';
import TrafficTrend from '../pages/shops/TrafficTrend';
import ShopCompare from '../pages/shops/ShopCompare';
import ShopDataBoard from '../pages/shops/ShopDataBoard';
import OrderPreList from '../pages/order/OrderPreList';
import OrderReport from '../pages/order/OrderReport';
import OrderAuditWaitList from '../pages/order/audit/OrderAuditWaitList';
import OrderAuditDoneList from '../pages/order/audit/OrderAuditDoneList';
import OrderAllAuditList from '../pages/order/audit/OrderAllAuditList';
import OrderAuditInProgress from '../pages/order/audit/OrderAuditInProgress';
import OrderRenewalList from '../pages/order/OrderRenewalList';
import OrderNonDeviceList from '../pages/order/OrderNonDeviceList';
import OrderBillRemindList from '../pages/order/OrderBillRemindList';
import OrderDispatchStats from '../pages/order/OrderDispatchStats';
import OperationLogs from '../pages/manager/OperationLogs';
import OperatingDataOverview from '../pages/financial/OperatingDataOverview';
import CashflowData from '../pages/financial/CashflowData';
import CashflowEntryRecords from '../pages/financial/CashflowEntryRecords';
import InstallmentLedger from '../pages/financial/InstallmentLedger';
import RRZFinancialLedger from '../pages/financial/RRZFinancialLedger';
import ExportTasks from '../pages/manager/ExportTasks';
import PurchasePendingQuoteList from '../pages/purchase/management/PurchasePendingQuoteList';
import PurchaseUndeclaredList from '../pages/purchase/management/PurchaseUndeclaredList';
import PurchaseDeclaredList from '../pages/purchase/management/PurchaseDeclaredList';
import PurchaseDeliveryPendingList from '../pages/purchase/management/PurchaseDeliveryPendingList';
import FinancialPendingList from '../pages/purchase/financial/FinancialPendingList';
import FinancialApprovalList from '../pages/purchase/financial/FinancialApprovalList';
import FinancialFinishedList from '../pages/purchase/financial/FinancialFinishedList';
import Teams from '../pages/team/Teams';
import TeamAuditConfigs from '../pages/team/TeamAuditConfigs';
import TeamAuditWorkbench from '../pages/order/team-audit/TeamAuditWorkbench';
import DClassCancelList from '../pages/order/team-audit/DClassCancelList';

import PendingDecisionList from '../pages/order/decision/PendingDecisionList';
import DoneDecisionList from '../pages/order/decision/DoneDecisionList';
import GroupChatPendingList from '../pages/order/audit/GroupChatPendingList';
import DeliveryManagementList from '../pages/order/delivery/DeliveryManagementList';
import ReceiptManagementList from '../pages/order/delivery/ReceiptManagementList';

export interface RouteConfigItem {
  key: string; // Route path
  icon?: React.ReactNode;
  label: string; // Menu label
  component?: React.ComponentType; // Component to render
  permission?: string; // Permission required
  children?: RouteConfigItem[]; // Sub-menus/routes
  hideInMenu?: boolean; // If true, not shown in menu but route is registered
}

export const routeConfig: RouteConfigItem[] = [
  {
    key: '/welcome',
    icon: <HomeOutlined />,
    label: '首页',
    component: Welcome,
  },
  {
    key: 'order-center',
    icon: <ShoppingOutlined />,
    label: '订单中心',
    children: [
      {
        key: '/order/processing',
        icon: <AuditOutlined />,
        label: '订单预处理',
        component: OrderPreList,
        permission: 'orders.pre',
      },
      {
        key: 'order-audit-group',
        icon: <AuditOutlined />,
        label: '订单初审',
        children: [
          {
            key: '/order/audit/wait',
            label: '待审订单',
            component: OrderAuditWaitList,
            permission: 'orders.audit.wait',
          },
          {
            key: '/order/audit/in-progress',
            label: '在审订单',
            component: OrderAuditInProgress,
            permission: 'orders.audit.in_progress',
          },
          {
            key: '/order/audit/done',
            label: '已审订单',
            component: OrderAuditDoneList,
            permission: 'orders.audit.done',
          },
          {
            key: '/order/group-chat/pending',
            label: '待建沟通群',
            component: GroupChatPendingList,
            permission: 'orders.group_chat.pending',
          },
          {
            key: '/order/audit/:orderNo',
            label: '订单审核',
            icon: <AuditOutlined />,
            component: OrderAuditPage,
            permission: 'orders.audit.detail',
            hideInMenu: true,
          },
        ],
      },
      {
        key: 'order-team-audit-group',
        icon: <AuditOutlined />,
        label: '团队审核工作台',
        children: [
          {
            key: '/order/team-audit/workbench',
            label: '团队所有订单',
            component: TeamAuditWorkbench,
            permission: 'orders.team_audit.workbench',
          },
          {
            key: '/order/team-audit/d-class-cancel',
            label: 'D类待取消订单',
            component: DClassCancelList,
            permission: 'orders.team_audit.d_class_cancel',
          }
        ],
      },
      {
        key: 'order-decision-group',
        icon: <AuditOutlined />,
        label: '订单决策',
        children: [
          {
            key: '/order/decision/pending',
            label: '待决策订单',
            component: PendingDecisionList,
            permission: 'orders.decision.pending',
          },
          {
            key: '/order/decision/done',
            label: '已决策订单',
            component: DoneDecisionList,
            permission: 'orders.decision.done',
          },
        ],
      },
      {
        key: 'logistics-management-group',
        icon: <AppstoreOutlined />,
        label: '物流管理',
        children: [
          {
            key: '/order/delivery/delivery-management',
            label: '发货记录',
            component: DeliveryManagementList,
            permission: 'orders.logistics.delivery_management',
          },
          {
            key: '/order/delivery/receipt-management',
            label: '签收管理',
            component: ReceiptManagementList,
            permission: 'orders.logistics.receipt_management',
          },
        ],
      },
      {
        key: '/order/audit/all-done',
        icon: <AuditOutlined />,
        label: '所有已审',
        component: OrderAllAuditList,
        permission: 'orders.audit.alldone',
      },
      {
        key: '/order/list',
        icon: <FileTextOutlined />,
        label: '订单总览',
        component: Orders,
        permission: 'orders.list',
      },
      {
        key: '/order/renewal',
        icon: <FileTextOutlined />,
        label: '续租订单',
        component: OrderRenewalList,
        permission: 'orders.renewal',
      },
      {
        key: '/order/non-device',
        icon: <FileTextOutlined />,
        label: '非设备订单',
        component: OrderNonDeviceList,
        permission: 'orders.non_device',
      },
      {
        key: '/order/bill-remind',
        icon: <BellOutlined />,
        label: '订单提醒列表',
        component: OrderBillRemindList,
        permission: 'orders.bill_remind',
      },
      {
        key: '/order/dispatch-stats',
        icon: <BarChartOutlined />,
        label: '派单统计',
        component: OrderDispatchStats,
        permission: 'orders.dispatch_stats',
      },
      {
        key: '/order/operation-logs',
        icon: <FileTextOutlined />,
        label: '操作日志',
        component: OperationLogs,
        permission: 'orders.operation_logs',
      },
      {
        key: '/export-tasks',
        icon: <DownloadOutlined />,
        label: '我的导出',
        component: ExportTasks,
        permission: 'users.export_tasks',
      },
      {
        key: '/order/report/:orderNo',
        label: '订单报告',
        component: OrderReport,
        // permission: 'orders.audit', // Assuming permission key
        hideInMenu: true,
      },
    ],
  },
  {
    key: 'purchase-management',
    icon: <ShopOutlined />,
    label: '采购管理',
    children: [
      {
        key: '/purchase/pending-quote',
        label: '待报价列表',
        component: PurchasePendingQuoteList,
        permission: 'purchase.quote',
      },
      {
        key: '/purchase/delivery-pending',
        label: '微签管理',
        component: PurchaseDeliveryPendingList,
        permission: 'purchase.delivery_pending',
      },
      {
        key: '/purchase/undeclared',
        label: '待申报列表',
        component: PurchaseUndeclaredList,
        permission: 'purchase.undeclared',
      },
      {
        key: '/purchase/declared',
        label: '已申报列表',
        component: PurchaseDeclaredList,
        permission: 'purchase.declared',
      },
    ],
  },
  {
    key: 'financial-management',
    icon: <AccountBookOutlined />,
    label: '财务管理',
    children: [
      {
        key: '/purchase/financial/pending',
        label: '待办理采购单',
        component: FinancialPendingList,
        permission: 'financial.purchase.pending',
      },
      {
        key: '/purchase/financial/finished',
        label: '已完结列表',
        component: FinancialFinishedList,
        permission: 'financial.purchase.finished',
      },
    ],
  },
  {
    key: 'traffic-quality',
    icon: <FundOutlined />,
    label: '流量质量看板',
    children: [
      {
        key: '/traffic-quality-analysis',
        icon: <BarChartOutlined />,
        label: '业务数据总览',
        component: ShopDataBoard,
        permission: 'traffic.analysis',
      },
      {
        key: '/traffic-quality-shop-trend',
        icon: <LineChartOutlined />,
        label: '流量质量趋势',
        component: TrafficTrend,
        permission: 'traffic.shop_trend',
      },
      {
        key: '/traffic-quality-shop-compare',
        icon: <AppstoreOutlined />,
        label: '店铺数据对比',
        component: ShopCompare,
        permission: 'traffic.shop_compare',
      },
    ],
  },
  {
    key: 'overdue-dashboard-group',
    icon: <ExclamationCircleOutlined />,
    label: '逾期数据看板',
    children: [
      {
        key: '/overdue-store-statistics',
        label: '逾期店铺统计',
        component: OverdueStoreStatistics,
        permission: 'overdue.store_statistics',
      },
      {
        key: '/overdue-bills-statistics',
        label: '逾期账单统计',
        component: OverdueBillsStatistics,
        permission: 'overdue.bills_statistics',
      },
      {
        key: '/overdue-data-analysis',
        label: '逾期数据统计',
        component: OverdueDataStatistics,
        permission: 'overdue.data_analysis',
      },
      {
        key: '/overdue-loss-analysis',
        label: '逾期资损统计',
        component: OverdueAmountStatistics,
        permission: 'overdue.loss_analysis',
      },
      {
        key: '/overdue/bad-debt-data',
        label: '坏账数据统计',
        component: BadDebtDataStatistics,
        permission: 'overdue.bad_debt_data',
      },
      {
        key: '/overdue/bad-debt-amount',
        label: '坏账金额统计',
        component: BadDebtAmountStatistics,
        permission: 'overdue.bad_debt_amount',
      },
    ],
  },
  {
    key: 'financial-data',
    icon: <AccountBookOutlined />,
    label: '财务数据',
    children: [
      {
        key: '/financial/operating-data-overview',
        label: '经营数据总览',
        component: OperatingDataOverview,
        permission: 'financial.operating_data',
      },
      {
        key: '/financial/cashflow-data',
        label: '现金流数据',
        component: CashflowData,
        permission: 'financial.cashflow_data',
      },
      {
        key: '/financial/cashflow-entry-records',
        label: '现金流录入记录',
        component: CashflowEntryRecords,
        permission: 'financial.cashflow_data',
      },
      {
        key: '/financial/installment-ledger',
        label: '分期账单明细',
        component: InstallmentLedger,
        permission: 'financial.installment_ledger',
      },
      {
        key: '/financial/rrz-financial-ledger',
        label: '人人租财务明细',
        component: RRZFinancialLedger,
        permission: 'financial.cashflow_data',
      },
    ],
  },
  {
    key: 'company-management',
    icon: <BankOutlined />,
    label: '公司管理',
    children: [
      {
        key: '/staffs',
        icon: <SolutionOutlined />,
        label: '员工管理',
        component: Staffs,
        permission: 'company.staffs',
      },
      // {
      //   key: '/departments',
      //   icon: <ApartmentOutlined />,
      //   label: '组织架构管理',
      //   component: Departments,
      //   permission: 'company.departments',
      // },
      {
        key: '/shops',
        icon: <ShopOutlined />,
        label: '店铺管理',
        component: Shops,
        permission: 'company.shops',
      },
      {
        key: '/main-bodies',
        icon: <BankOutlined />,
        label: '主体管理',
        component: MainBodies,
        permission: 'company.main_bodies',
      },
    ],
  },
  {
    key: 'team-management',
    icon: <TeamOutlined />,
    label: '团队管理',
    children: [
      {
        key: '/teams',
        label: '团队配置',
        component: Teams,
        permission: 'company.teams',
      },
      {
        key: '/team-audit-configs',
        label: '审核项配置',
        component: TeamAuditConfigs,
        permission: 'company.team_audit_configs',
      },
    ],
  },
  {
    key: 'system-management',
    icon: <SettingOutlined />,
    label: '系统管理',
    children: [
      {
        key: '/account',
        icon: <SolutionOutlined />,
        label: '爬虫账户管理',
        component: Accounts,
        permission: 'system.accounts',
      },
      {
        key: '/permissions',
        icon: <SafetyCertificateOutlined />,
        label: '权限管理',
        component: Permissions,
        permission: 'system.permissions',
      },
      {
        key: '/roles',
        icon: <IdcardOutlined />,
        label: '角色管理',
        component: Roles,
        permission: 'system.roles',
      },
      {
        key: '/brands',
        icon: <AppstoreOutlined />,
        label: '品牌管理',
        component: Brands,
      },
      {
        key: '/lock-fee-configs',
        icon: <SettingOutlined />,
        label: '上锁费用管理',
        component: LockFeeConfigs,
      },
      {
        key: '/pre-rating-thresholds',
        icon: <SettingOutlined />,
        label: '预评级阈值管理',
        component: PreRatingThresholds,
      },
    ],
  },
];
